import { useState } from 'react';
import { CopyButton } from './CustomerParts';

const NOTE_LINES = 4;

// The "who are they" card: contact details you can act on (mail, call, copy)
// and the staff-only note, clamped so a long note can't push everything down.
export default function CustomerDetails({ customer, open, onToggle }) {
  const [notesOpen, setNotesOpen] = useState(false);
  const notes = customer.notes || '';
  const longNote = notes.split('\n').length > NOTE_LINES || notes.length > 220;

  const addressLines = [
    customer.address1,
    customer.address2,
    [customer.city, customer.county].filter(Boolean).join(', '),
    customer.postcode,
    customer.country
  ].filter(Boolean);

  return (
    <section className="cx-card cx-details">
      <button type="button" className="cx-card-head" onClick={onToggle} aria-expanded={open}>
        <h2>Contact details</h2>
        <i className={`fas fa-chevron-${open ? 'up' : 'down'} cx-card-caret`} aria-hidden="true"></i>
      </button>

      {open && (
        <dl className="cx-dl">
          <div className="cx-dl-row">
            <dt><i className="fas fa-envelope" aria-hidden="true"></i> Email</dt>
            <dd>
              {customer.email
                ? <><a href={`mailto:${customer.email}`}>{customer.email}</a><CopyButton value={customer.email} label="email address" /></>
                : <span className="cx-muted">Not set</span>}
            </dd>
          </div>
          <div className="cx-dl-row">
            <dt><i className="fas fa-phone" aria-hidden="true"></i> Phone</dt>
            <dd>
              {customer.phoneNumber
                ? <><a href={`tel:${String(customer.phoneNumber).replace(/[^\d+]/g, '')}`}>{customer.phoneNumber}</a><CopyButton value={customer.phoneNumber} label="phone number" /></>
                : <span className="cx-muted">Not set</span>}
            </dd>
          </div>
          <div className="cx-dl-row">
            <dt><i className="fas fa-location-dot" aria-hidden="true"></i> Address</dt>
            <dd>
              {addressLines.length > 0
                ? <address>{addressLines.map((line, i) => <span key={i}>{line}</span>)}</address>
                : <span className="cx-muted">Not set</span>}
            </dd>
          </div>
          <div className="cx-dl-row">
            <dt><i className="fas fa-id-badge" aria-hidden="true"></i> Role</dt>
            <dd>{customer.role_type || 'Customer'}</dd>
          </div>
        </dl>
      )}

      {open && notes && (
        <div className="cx-note">
          <div className="cx-note-label"><i className="fas fa-lock" aria-hidden="true"></i> Staff note</div>
          <p className={`cx-note-text ${longNote && !notesOpen ? 'is-clamped' : ''}`}>{notes}</p>
          {longNote && (
            <button type="button" className="cx-link-btn" onClick={() => setNotesOpen((v) => !v)} aria-expanded={notesOpen}>
              {notesOpen ? 'Show less' : 'Read more'}
            </button>
          )}
        </div>
      )}
    </section>
  );
}
